import { FC, useEffect, useState } from 'react';
import { RadioGroup } from 'react-bootstrap-formutil';
import BorderRadio from 'components/BorderRadio';
import FormGroup from 'components/FormGroup';
import { AccountFormutil } from 'modules/Open';
import values from 'stores/values';
import { CategoryEnum, OpenType } from 'types/customer';
import { HIDE_IRA } from 'utils/constants';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import individualIcon from './images/individual.png';
import iraIcon from './images/ira.png';
import styles from './style.scss';

export interface CategoryFormutil {
    category: CategoryEnum;
}

/**
 *   账户类别选择组件（个人或者IRA账户）
 */
const Category: FC<ProgressFormProps<CategoryFormutil>> = ({ onSubmit, $formutil }) => {
    const { category: formCategory } = $formutil.$params;
    const { temporaryOpenType: storageTempOpenType } = values.getParams<AccountFormutil>();
    // 只能根据是否发生点击决定跳转下一步，点击后跳转对应类型二级页面
    const [shouldSubmit, setShouldSubmit] = useState(false);

    useEffect(() => {
        if (shouldSubmit) {
            onSubmit('../account');
        }
    }, [shouldSubmit, onSubmit]);

    return (
        <form noValidate>
            <h3 className="open-title mb-4">{__('CHOOSE YOUR ACCOUNT TYPE')}</h3>
            <FormGroup<CategoryEnum>
                name="category"
                checker={value => !!value || __('请选择账户类型')}
                /**
                 * @tag HIDE_IRA
                 * 临时隐藏ira, 方便后续代码开发合并
                 */
                $defaultValue={
                    HIDE_IRA || storageTempOpenType === OpenType.INDIVIDUAL ? CategoryEnum.INDIVIDUAL : undefined
                }>
                <RadioGroup>
                    <BorderRadio
                        value={CategoryEnum.INDIVIDUAL}
                        id="category_individual"
                        active={formCategory === CategoryEnum.INDIVIDUAL}
                        labelOptions={{
                            img: individualIcon,
                            imgClassName: styles.img,
                            title: __('Individual Account'),
                            description: __(
                                "Open an account using your SSN or another country/region's identification document"
                            ),
                            showArrow: true
                        }}
                        checkedType="border"
                        onClick={() => setShouldSubmit(true)}
                    />
                    {/* @tag HIDE_IRA 鉴于ira验收周期过长, 所以临时隐藏ira, 方便后续代码开发合并, 验收完毕打开的时候需要重新回测 */}
                    {/* 开户方式为Individual的时候，不显示IRA选项, 只能选择Individual下的子分支 */}
                    {HIDE_IRA || storageTempOpenType === OpenType.INDIVIDUAL ? (
                        <></>
                    ) : (
                        <BorderRadio
                            value={CategoryEnum.IRA}
                            id="category_ira"
                            active={formCategory === CategoryEnum.IRA}
                            labelOptions={{
                                img: iraIcon,
                                imgClassName: styles.img,
                                title: __('Retirement Account'),
                                description: __(
                                    'Individual Retirement Account, available to individual U.S. tax residents only. Including Traditional, Roth, Rollover IRAs'
                                ),
                                showArrow: true
                            }}
                            checkedType="border"
                            onClick={() => setShouldSubmit(true)}
                        />
                    )}
                </RadioGroup>
            </FormGroup>
        </form>
    );
};

export default withProgressForm({
    id: 'category',
    basePath: 'open',
    effect: ['account'],
    showProgressBar: false
})(Category);
